import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { createTemplate } from '../api-client';
import type { WaterfallRow } from '../components/waterfallTypes';

interface SaveTemplatePayload {
  name: string;
  campaign_type: string;
  rows: WaterfallRow[];
  source?: 'template' | 'launch';
  campaign_sfdc_id?: string;
  campaign_name?: string;
}

export function useSaveAsTemplate() {
  const { apiFetch } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: SaveTemplatePayload) => createTemplate(apiFetch, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['launcher', 'templates'] });
    },
    // WaterfallConfig catches duplicate_template_name locally and shows its own
    // specific message — suppress the generic global toast to avoid double-firing.
    meta: { suppressErrorToast: true },
  });
}
